/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Checkout_PreviewInputs */

const en_carrier_notices_checkout_preview = /** @type {(inputs: Carrier_Notices_Checkout_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout preview`)
};

const es_carrier_notices_checkout_preview = /** @type {(inputs: Carrier_Notices_Checkout_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de checkout`)
};

/**
* | output |
* | --- |
* | "Checkout preview" |
*
* @param {Carrier_Notices_Checkout_PreviewInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_checkout_preview = /** @type {((inputs?: Carrier_Notices_Checkout_PreviewInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Checkout_PreviewInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_checkout_preview(inputs)
	return es_carrier_notices_checkout_preview(inputs)
});